import { useMemo } from 'react';
import { useWelcomeSurveyRedirect } from './useWelcomeSurveyRedirect';
import { useContentPackageWizardRedirect } from './useContentPackageWizardRedirect';
import { getRegion, Region } from '~/src/regions/config/utils';

interface RedirectInfo {
  shouldRedirect: boolean;
  target: string | null;
}

export const useOnboardingRedirect = (): RedirectInfo => {
  const shouldRedirectToWelcome = useWelcomeSurveyRedirect();
  const shouldRedirectToContentWizard = useContentPackageWizardRedirect();
  const currentPath = window.location.pathname;
  const region = getRegion();

  const redirectInfo = useMemo((): RedirectInfo => {
    const isOnboardingPath = (path: string): boolean => {
      return (
        path.includes('/content-package-wizard') || path.includes('/welcome')
      );
    };

    if (
      region !== Region.US &&
      currentPath.includes('/content-package-wizard')
    ) {
      return { shouldRedirect: true, target: '/library' };
    }

    if (isOnboardingPath(currentPath)) {
      return { shouldRedirect: false, target: null };
    }

    if (shouldRedirectToWelcome) {
      return { shouldRedirect: true, target: '/welcome' };
    }

    if (shouldRedirectToContentWizard) {
      return { shouldRedirect: true, target: '/content-package-wizard' };
    }

    return { shouldRedirect: false, target: null };
  }, [
    shouldRedirectToWelcome,
    shouldRedirectToContentWizard,
    currentPath,
    region,
  ]);

  return redirectInfo;
};

export default useOnboardingRedirect;
